import React from 'react';
import Input from '@mui/material/Input';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import { MONTHS } from '../../../../../services/config/CONST';

interface Props {
  value: string | undefined;
  onValueChange: (value: string) => void;
}
function StartMonthEditor({ value, onValueChange }: Props): JSX.Element {
  return (
    <FormControl fullWidth error>
      <Select
        input={<Input />}
        value={value}
        onChange={(event) => onValueChange(event.target.value as string)}
        style={{ width: '100%' }}
        error={!value}
      >
        {MONTHS.map((monthItem) => (
          <MenuItem key={monthItem.id} value={monthItem.title}>
            {monthItem.title}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{value ? '' : 'Incorrect entry'}</FormHelperText>
    </FormControl>
  );
}

export default StartMonthEditor;
